
export function InCypress()
{
  return !!(window as any).Cypress;
}